import i18n from '../../../lang/i18n'

export default {
  getTime (state) {
    return state.time
  },
  getReport (state) {
    return state.report
  },
  getType (state) {
    return state.type
  },
  getOrganization (state) {
    return state.organization
  },
  getStartYear (state) {
    return state.start_year
  },
  getEndYear (state) {
    return state.end_year
  },
  getReportHashtag (state) {
    return state.report_hashtag
  },
  getDataChart (state) {
    let data = []
    // eslint-disable-next-line camelcase
    let data_incorrective = []
    // eslint-disable-next-line camelcase
    let report_corrective = []

    // 0 is incorrective, 1 is corrective total=[0,1];
    let incorrective = state.report_corrective.filter(item => item.status === 0)
    let corrective = state.report_corrective.filter(item => item.status === 1)

    // eslint-disable-next-line camelcase
    report_corrective = state.report_corrective.reduce((row, item) => {
      row[item.checklist_item_status.code] = [...row[item.checklist_item_status.code] || [], item]
      return row
    }, {})
    // return report_corrective
    // eslint-disable-next-line camelcase
    for (var key in report_corrective) {
      data_incorrective.push(
        {
          'data': [report_corrective[key].filter(item => item.status === 0).length, report_corrective[key].filter(item => item.status === 1).length],
          'label': key,
          'backgroundColor': report_corrective[key][0].checklist_item_status.color
        }
      )
    }
    data.push(
      {
        'data': [incorrective.length, corrective.length],
        'label': i18n.t('report.total'),
        'backgroundColor': '#29363D'
      }
    )
    return data.concat(data_incorrective)
    // eslint-disable-next-line no-unreachable
    state.report_corrective.forEach(element => {})
  }
}



// WEBPACK FOOTER //
// ./src/store/module/report/getters.js